import React from 'react';
import FeedLayout from '../Includes/FeedLayout';
import ProfileChips from '../Includes/ProfileChips';
import MenuPerfil from '../Includes/MenuPerfil';
import { useTranslation } from 'react-i18next';

import './styles.css';

export default function Sobre() {
  const { t } = useTranslation();
  return (
    <FeedLayout active="profile">
      <div className="sobre-container">
        <div className="feed-top">{t('pages.about.title')}</div>
        <ProfileChips active="profile" />
        <section className="body">
          <div className="conteudo">
            <div className="sobre-texto">
              <h2>{t('pages.about.whoAreWe.title')}</h2>
              <p>{t('pages.about.whoAreWe.infoOne')}</p>
              <ul>
                <li>{t('pages.about.whoAreWe.listItemOne')}</li>
                <li>{t('pages.about.whoAreWe.listItemTwo')}</li>
                <li>{t('pages.about.whoAreWe.listItemThree')}</li>
                <li>{t('pages.about.whoAreWe.listItemFour')}</li>
              </ul>
              <p>{t('pages.about.whoAreWe.infoTwo')}</p>
              <h2>{t('pages.about.howItWorks.title')}</h2>
              <p>{t('pages.about.howItWorks.infoOne')}</p>
              <p>{t('pages.about.howItWorks.infoTwo')}</p>
              <p>{t('pages.about.howItWorks.infoThree')}</p>
              <p>{t('pages.about.howItWorks.infoFour')}</p>
            </div>
            <MenuPerfil />
          </div>
        </section>
      </div>
    </FeedLayout>
  );
}
